import React from "react";
import CurrencyIcon from '../../images/currency.png'

const AutoPayModal = props => {
  return (
    <div className={`${props.show ? "active popup-modal loading-modal" : ""}`}>
      <div className="dark-bg">{/* White frosty background */}</div>
      <div className="modal">
        <div class="modal-container">
          <button onClick={() => props.hideModal()} className="close-icon">
            <i class="material-icons">close</i>
          </button>
          <img src={CurrencyIcon} className="popup-icon" alt="" />
          <h2>What is AutoPay?</h2>
          <p>
            If you plan to make consistent monthly payments and don’t want to have to do it manually
            every month AutoPay is the answer. By turning on AutoPay, we will make a payment with
            the information you provide on your due date every month.{" "}
          </p>

          <p>
            You can stop AutoPay at anytime by coming back here or giving us a call. If you have any
            questions please call us at 888.267.7200, M-F 7AM-7PM or Saturday 9AM-1PM.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AutoPayModal;



// WEBPACK FOOTER //
// ./src/components/autopay-modal/component.js